import { createRouter, createWebHistory } from 'vue-router'
import { authGuard, mfaGuard } from './guards'
import routes from './routes'

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(authGuard)
router.beforeEach(mfaGuard)
export default router
